<template>
  <section :class="`brand-area ${style_2 ? 'light-bg-s pb-60' : 'brand-area-d'}`">
    <div :class="`container ${style_2 ? 'custom-conatiner' : ''}`">
      <swiper
              :modules="[Autoplay]"
              :slides-per-view="1"
              :space-between="30"
              :autoplay="{ delay: 2500, disableOnInteraction: false }"
              :breakpoints="{ 550: { slidesPerView: 3 }, 768: { slidesPerView: 4 }, 1200: { slidesPerView: 5 }, 1400: { slidesPerView: 6 } }"
              :class="`brand-slider swiper-container ${style_2 ? 'brand-slider-2 pt-35 pb-30' : 'pt-50 pb-45'}`">
        <swiper-slide v-for="(brand, i) in brand_logos" :key="i" class="brand-item w-img swiper-slide">
          <a href="#"><img :src="brand" alt="brand"></a>
        </swiper-slide>
      </swiper>
    </div>
  </section>
</template>

<script>

import { Swiper, SwiperSlide } from 'swiper/vue';
import { Autoplay } from 'swiper/modules';

export default {
  name: 'BrandSlider',
  components: {
    Swiper,
    SwiperSlide,
  },
  props: {
    style_2: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    const brand_logos = [
      require('@/assets/images/brand/honor.jpg'),
      require('@/assets/images/brand/infinix.jpg'),
      require('@/assets/images/brand/samsung.jpg'),
      require('@/assets/images/brand/redmi.jpg'),
      require('@/assets/images/brand/anker.jpg'),
      require('@/assets/images/brand/baseus.jpg'),
      require('@/assets/images/brand/joyroom.jpg'),
    ];

    const slider_setting = {
      slidesPerView: 1,
      spaceBetween: 30,
      breakpoints: {
        550: { slidesPerView: 3 },
        768: { slidesPerView: 4 },
        1200: { slidesPerView: 5 },
        1400: { slidesPerView: 6 }
      },
      modules: [Autoplay],
      autoplay: { delay: 2500, disableOnInteraction: false }
    };

    return {
      brand_logos,
      slider_setting,
      Autoplay,
    };
  }
};
</script>

<style scoped>
/* Add your styles here */
</style>
